export default __webpack_public_path__ + "static/media/ambush.d5646f34.png";